export enum ProfileActionsType {
  PROFILE_ATTACH_LISTENERS = 'app/modules/personal/PROFILE_ATTACH_LISTENERS',
  PROFILE_DETACH_LISTENERS = 'app/modules/personal/PROFILE_DETACH_LISTENERS',
}
